import styled from '@emotion/styled'
import React, { ReactNode } from 'react'
import BreakPoints from '../../styles/breakPoints'
import ColumnPath, { IColumnPath } from '../atoms/columnPath'
import ColumnFooter from './ColumnFooter'
import ColumnHeader from './columnHeader'
import ColumnHeadNav from './columnHeadNav'
import ScrollTop from '../atoms/scrollTop'

const Wrapper = styled.div`
  background: #ffffff;
  margin: 0 auto;
  padding: 120px 0 0;
  line-height: 1.6em;

  &#pageTop {
    padding-top: 120px !important;
  }

  .relation-link {
    a {
      color: #0075ff;

      &:hover {
        text-decoration: underline solid #0075ff;
      }
    }

    + .relation-link {
      margin-top: -20px;
    }
  }

  a {
    color: #243650;

    &:hover {
      color: #00b5a6;
    }

    &.column-detail-link {
      position: relative;
      z-index: 1;
      color: #0075ff;
      margin-bottom: 20px;

      &:hover {
        text-decoration: underline solid #0075ff;
      }
    }
  }

  .p-foot-inner {
    .anim-fade-up {
      opacity: 1;
      visibility: visible;
      transform: translateY(0px);
    }
  }

  ${BreakPoints.large} {
    padding: 30px 0 0;
  }
`
const Nav = styled.nav`
  background: #ffffff;
  display: flex;
  align-items: center;
  padding: 1px 30px 0 10px;
  height: 40px;
  top: 80px;
  width: 100vw;
  justify-content: space-between;
  position: fixed;
  z-index: 2;
  border-top: solid 1px #e5e5e5;
  border-bottom: solid 1px #e5e5e5;

  a {
    color: #505050;

    &:hover {
      color: #00b5a6;
    }
  }

  ${BreakPoints.xxLarge} {
    padding: 0;
    height: 80px;
    flex-wrap: wrap-reverse;
    justify-content: space-around;
  }

  ${BreakPoints.large} {
    display: none;
  }
`

export type PageType = 'index' | 'list' | 'detail'

type Props = {
  /** パンくずパス */
  paths?: IColumnPath[]
  /** 子要素 */
  children: ReactNode
}

/**
 * コラム用レイアウト
 * @constructor
 */
const ColumnLayout = ({ paths, children }: Props) => (
  <>
    <ColumnHeader />
    <noscript>Javascriptが無効なため有効にしてください</noscript>
    <Nav>
      {paths && <ColumnPath paths={paths} />}
      <ColumnHeadNav />
    </Nav>
    <Wrapper id="pageTop">
      {children}
      <ColumnFooter />
      <ScrollTop />
    </Wrapper>
  </>
)

export default ColumnLayout
